import React from "react";
import { useCurrentRefinements } from "react-instantsearch";
import CustomClearRefinements from "./ClearRefinements/ClearRefinements";
import CustomCurrentRefinements from "./CustomCurrentRefinments/CustomCurrentRefinements";

const CurrentRefinementsList = (props) => {
    const { items } = useCurrentRefinements(props);

    return (
        items.length > 0 && (
            <div className="search-refinements">
                <CustomClearRefinements />
                <CustomCurrentRefinements />
            </div>
        )
    );
};

export default CurrentRefinementsList;
